<!-- main -->
<template>
  <div class="home">
    <player :musicList="musicList"/>
    <head-line 
      title="KILLER WANTED"
      :menu="menu"
      :mediaList="media"
      @select="select"
      ref="headLine"
      ></head-line>
    <full-page class="full-page" ref="fullpage"  :options="options">
      <div class="section">
        <banner-wrapper/>
      </div>
      <div class="section the-story">
        <the-story/>
      </div>
      <div class="section">
        <gallery-wrapper :imgList="imgList"/>
      </div>
    </full-page>
  </div>
</template>

<script>
import headLine from '../components/head-line.vue'
import bannerWrapper from '../components/banner-wrapper.vue'
import theStory from '../components/the-story.vue'
import galleryWrapper from '../components/gallery-wrapper.vue'
import player from '../components/player.vue'
export default {
  data () {
    return {
      selectIndex: 0,
      options: {
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        verticalCentered: true,
        resize: true,
        afterLoad: this.afterLoad,
        anchors: [
          'home',
          'theStory',
          'gallery',
          'roadMap',
        ]
      },
      menu: ['HOME', 'THE STORY', 'GALLERY'],
      media:[
        {
          img: require('../assets/tw.jpg'),
          link: 'https://twitter.com/Killer__Wanted'
        },
        {
          img: require('../assets/os.jpg'),
          link: 'https://opensea.io/collection/killer-wanted'
        }
      ],
      imgList: [
        require('../assets/1.png'),
        require('../assets/2.png'),
        require('../assets/3.png'),
        require('../assets/4.png'),
        require('../assets/5.png'),
        require('../assets/6.png'),
        require('../assets/7.png'),
        require('../assets/8.png')
      ],
      musicList: [
        {
          songer: 'Jay',
          title: 'DRIFTING',
          song: require('../assets/drifting.mp3')
        },
        {
          songer: 'Mark Ronson',
          title: 'Uptown Funk',
          song: require('../assets/Uptown Funk.mp3')
        },
        {
          songer: 'Teriyaki Boyz',
          title: 'Tokyo Drift',
          song: require('../assets/Tokyo Drift.mp3')
        }
      ]
    }
  },
  components: {
    headLine,
    bannerWrapper,
    theStory,
    galleryWrapper,
    player
  },
  methods: {
    afterLoad (...arg) {
      const direction = arg[1]
      const index = direction.index
      localStorage.setItem('index', index)
      this.$refs.headLine.selectIndex = index
    },
    select (index) {
      const anchors = this.options.anchors[index]
      this.$refs.fullpage.api.moveTo(anchors)
    }
  }
}
</script>
<style lang='scss' rel='stylesheet/scss' scoped>
@import '../style/media.scss';
.home{
  font-size: 0;
}
.section {
  background-color: #EEEBE6;
  padding-top:80px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
</style>